import { render, staticRenderFns } from "./financialStatistics.vue?vue&type=template&id=4554dd4b&scoped=true&"
import script from "./financialStatistics.vue?vue&type=script&lang=js&"
export * from "./financialStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4554dd4b",
  null
  
)

export default component.exports